<template>
  <div class="settlement-center">
    <div class="title-wrap">
      <!-- <div class="title-name">结算中心</div> -->
      <!-- <div class="tip-bind-card" v-if="!bankInfo.bank_card">
        <span>提现需要绑定银行卡</span>
        <span
          class="btn-bind btn"
          @click="$router.push({ name: 'settlementSet' })"
          >请前往绑定 ></span
        >
      </div> -->
      <div
        class="tip-bind-card"
        v-if="developerInfo.state == 0 || developerInfo.state == 3"
      >
        <span>成为迷你世界创作者，参与收益分成</span>
        <a
          :href="registerUrl"
          target="_blank"
          class="btn-bind btn"
          style="text-decoration: none"
          >前往了解 ></a
        >
      </div>
      <div class="tab-list">
        <div
          :class="[activeLabel == 1 ? 'income active' : 'income']"
          @click="changeLabel(1)"
        >
          <div class="income-content">工作室收益</div>
        </div>
        <div
          :class="[activeLabel == 2 ? 'record active' : 'record']"
          @click="changeLabel(2)"
        >
          <div class="record-content">结算记录</div>
        </div>
      </div>
    </div>
    <StudioWithdrawCard v-if="activeLabel == 1"></StudioWithdrawCard>
    <StudioIndexPageTable
      v-if="activeLabel == 2"
      class="indexPage"
    ></StudioIndexPageTable>
  </div>
</template>

<script>
import StudioWithdrawCard from './components/settlementCenter/StudioWithdrawCard';
import StudioIndexPageTable from './components/settlementCenter/StudioIndexPageTable';
import { mapState } from 'vuex';
// import { createRegisterUrl } from '@/utils';

export default {
  name: 'settlement',
  data() {
    return {
      registerUrl:
        'https://dev-wiki.mini1.cn/m/cyclopdeia?wikiMenuId=1634&wikiId=805', // createRegisterUrl(),
      isRefreshTable: false,
      activeLabel: 1,
      userTxt: '开发者',
    };
  },
  components: {
    StudioWithdrawCard,
    StudioIndexPageTable,
  },
  computed: {
    ...mapState(['bankInfo', 'developerInfo', 'userInfo']),
  },
  mounted() {
    this.settleCentrShow();
    //判断是否是427灰度测试
    let version = '';
    //判断是否是427版本
    if (this.userInfo.ver) {
      let ver = this.userInfo.ver.split('.');
      version =
        (parseInt(ver[0]) << 16) + (parseInt(ver[1]) << 8) + parseInt(ver[2]);
      if (version >= 68608) {
        this.userTxt = '开发者';
      } else {
        this.userTxt = '开发者';
      }
    }
  },
  methods: {
    refreshTable(val) {
      if (val) {
        this.isRefreshTable = true;
      }
    },
    changeLabel(index) {
      this.activeLabel = index;
    },
    //结算中心曝光埋点
    settleCentrShow() {
      this.$log('settlement_center_show', 85431, { v7: 1 });
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.settlement-center {
  padding-left: 0px;
  padding-top: 18px;
  color: #595959;
  .title-wrap {
    font-size: 24px;
    color: #595959;
    // padding-bottom: 15px;
    margin-bottom: 30px;
    .title-name {
      margin-bottom: 10px;
    }
    .tip-bind-card {
      font-size: 14px;
      color: #8c8c8c;
      margin-top: 8px;
      margin-left: 32px;
      .btn-bind {
        color: #2b6ddf;
        margin-left: 22px;
      }
    }
    .tab-list {
      margin-top: 13px;
      display: flex;
      color: #595959;
      font-size: 18px;
      margin-left: 32px;
      border-bottom: 1px solid #d9d9d9;
      .income {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        padding-bottom: 10px;
        margin-right: 19px;
        //margin-left: 19px;
        cursor: pointer;
        .income-content {
          //margin-left: 19px;
          line-height: 26px;
          -webkit-background-clip: text;
          //-webkit-text-fill-color: transparent;
        }
      }
      .income.active {
        border-bottom: 4px solid #fd9b21;
        position: relative;
        color: #fd9b21;
        &:before {
          display: block;
          content: '';
          width: 0;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent $--color-primary transparent;
          position: absolute;
          left: 50%;
          margin-left: -2px;
          bottom: 0;
        }
      }
      .record {
        padding-bottom: 10px;
        font-size: 20px;
        cursor: pointer;
        line-height: 26px;
        -webkit-background-clip: text;
        //-webkit-text-fill-color: transparent;
      }
      .record.active {
        border-bottom: 4px solid #fd9b21;
        position: relative;
        color: #fd9b21;
        &:before {
          display: block;
          content: '';
          width: 0;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent $--color-primary transparent;
          position: absolute;
          left: 50%;
          margin-left: -2px;
          bottom: 0;
        }
      }
    }
  }

  .btn {
    cursor: pointer;
    &:hover {
      filter: brightness(105%);
    }
  }
}
.indexPage {
  padding-left: 33px;
}
</style>
